// Centralized environment configuration for TradeMate Pro
// NOTE: In CRA, only REACT_APP_* variables are exposed to the browser

// ⚠️ SECURITY: No hardcoded keys! All keys must come from environment variables.
// If env vars are missing, the app will fail fast rather than use insecure defaults.

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// ⚠️ CRITICAL SECURITY FIX: Service key should NEVER be in frontend code!
// Service key bypasses RLS and should only be used in:
// - Supabase Edge Functions (server-side)
// - Backend Node.js scripts (server-side)
// - Admin operations (server-side only)
//
// If you need admin operations, use Edge Functions or RPC functions with SECURITY DEFINER

// Validate required environment variables
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('❌ Missing required environment variables!');
  console.error('Required: REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY');
  console.error('Check your .env file and restart the dev server.');
}

// Convenience headers for REST calls (anon key only)
export function supabaseAnonHeaders() {
  return {
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
  };
}

